import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../../../../components/global/Button';
import IntroLayoutIcon, {
  INTRO_LAYOUT_VARIANTS,
} from '../../../../../../../../../../../components/icons/IntroLayoutIcon';
import TrashIcon from '../../../../../../../../../../../components/icons/TrashIcon';

const propTypes = {
  cardSideId: PropTypes.string,
  cardSides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  onCardSideSelect: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disableCancel: PropTypes.bool,
};

const introLayoutVariants = [
  INTRO_LAYOUT_VARIANTS.FULL,
  INTRO_LAYOUT_VARIANTS.PORTRAITS_2,
  INTRO_LAYOUT_VARIANTS.LANDSCAPES_2,
  INTRO_LAYOUT_VARIANTS.PORTRAITS_3,
  INTRO_LAYOUT_VARIANTS.LANDSCAPES_3,
  INTRO_LAYOUT_VARIANTS.LANDSCAPES_4,
];

const LayoutSelector = ({
  cardSideId,
  cardSides,
  onCardSideSelect,
  onCancel,
  disableCancel,
}) => {
  if (!cardSides) {
    return null;
  }

  return (
    <div className="layout-selector">
      {cardSides.map((cardSide, index) => (
        <Button
          btnStyle="reset"
          key={cardSide.id}
          onClick={() => onCardSideSelect({ cardSide })}
          className={cardSideId === cardSide.id ? 'selected' : undefined}
        >
          <IntroLayoutIcon variant={introLayoutVariants[index]} />
        </Button>
      ))}
      <Button
        className="layout-selector-cancel-button"
        onClick={onCancel}
        disabled={disableCancel}
      >
        <TrashIcon />
      </Button>
    </div>
  );
};

LayoutSelector.propTypes = propTypes;

export default LayoutSelector;
